import { render, staticRenderFns } from "./GlobalNotice.vue?vue&type=template&id=0665a0ad&scoped=true"
import script from "./GlobalNotice.vue?vue&type=script&lang=js"
export * from "./GlobalNotice.vue?vue&type=script&lang=js"
import style0 from "./GlobalNotice.vue?vue&type=style&index=0&id=0665a0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665a0ad",
  null
  
)

export default component.exports